import { loadModules } from 'esri-loader';
import { arcgisConfig } from '../config';

let mapas = {};
let localSource = {};
loadModules([
    // Esri
    'esri/Basemap',

    // Layers
    'esri/layers/TileLayer',
    'esri/layers/WebTileLayer',
    'esri/layers/OpenStreetMapLayer',
    'esri/layers/VectorTileLayer',
    // Widgets
    'esri/widgets/BasemapGallery/support/LocalBasemapsSource',
], arcgisConfig.loaderOptions).then(([Basemap, TileLayer, WebTileLayer, OpenStreetMapLayer, VectorTileLayer, LocalBasemapsSource]) => {
    mapas = [
        new Basemap({
            id: 'streets-vector',
            baseLayers: new TileLayer({
                url: 'http://services.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer',
            }),
            thumbnailUrl: '//oefa.maps.arcgis.com/sharing/rest/content/items/04e903465a3e497aa669212e08927cee/info/thumbnail/world_street_map.jpg',
            title: 'Calles',
            tabindex: 1,
        }),
        new Basemap({
            id: 'satellite',
            baseLayers: new TileLayer({
                url: 'http://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer',
            }),
            thumbnailUrl: '//www.arcgis.com/sharing/rest/content/items/10df2279f9684e4a9f6a7f08febac2a9/info/thumbnail/thumbnail1584118328864.jpeg',
            title: 'Imágenes',
        }),
        new Basemap({
            id: 'streets',
            baseLayers: [new TileLayer({
                url: 'http://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer',
            }), new TileLayer({
                url: 'http://services.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer',
                isReference: true,
                displayLevels: [0, 1, 2, 3, 4, 5, 6, 7],
            }), new TileLayer({
                url: 'http://services.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer',
                isReference: true,
                displayLevels: [0, 1, 2, 3, 4, 5, 6, 7],
            }),
            ],
            thumbnailUrl: '//oefa.maps.arcgis.com/sharing/rest/content/items/3027a41ed46d4a9b915590d14fecafc0/info/thumbnail/imagery_labels.jpg',
            title: 'Imágenes con etiquetas',
        }),
        new Basemap({
            id: 'gray',
            baseLayers: [new TileLayer({
                url: 'http://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer',
            }), new TileLayer({
                url: 'http://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Reference/MapServer',
            })],
            thumbnailUrl: '//oefa.maps.arcgis.com/sharing/rest/content/items/79f66c69319e4408a8388c7eb22941a1/info/thumbnail/light_gray_canvas.jpg',
            title: 'Lona gris claro',
        }),
        new Basemap({
            id: 'dark-gray',
            baseLayers: [new TileLayer({
                url: 'http://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Base/MapServer',
            }), new TileLayer({
                url: 'http://services.arcgisonline.com/arcgis/rest/services/Canvas/World_Dark_Gray_Reference/MapServer',
            })],
            thumbnailUrl: '//oefa.maps.arcgis.com/sharing/rest/content/items/93bcc427e6584a40966a8bc6401b54c8/info/thumbnail/DGCanvasBase.png',
            title: 'Lona gris Oscuro',
        }),
        new Basemap({
            id: 'osm',
            baseLayers: new OpenStreetMapLayer(),
            thumbnailUrl: '//oefa.maps.arcgis.com/sharing/rest/content/items/d415dff75dd042258ceda46f7252ad70/info/thumbnail/temposm.jpg',
            title: 'OpenStreetMap',
        }),
        new Basemap({
            id: 'topo',
            baseLayers: new TileLayer({
                url: 'http://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer',
            }),
            thumbnailUrl: '//oefa.maps.arcgis.com/sharing/rest/content/items/1254ac139ecf423fbb04020bc57025a5/info/thumbnail/topo_map_2.jpg',
            title: 'Topográfico',
        }),
        new Basemap({
            baseLayers: new WebTileLayer({
                urlTemplate : 'https://mts1.google.com/vt/lyrs=s@186112443&hl=x-local&src=app&x={col}&y={row}&z={level}&s=Galile',
                copyright: 'Google Maps: Satelital',
            }),
            id: 'googlesat',
            thumbnailUrl: '/img/googlesatellite.png',
            title: 'Google Satelital',
        }),
        new Basemap({
            baseLayers: new WebTileLayer({
                urlTemplate : 'https://mts1.google.com/vt/lyrs=m@186112443,traficc&hl=x-local&src=app&x={col}&y={row}&z={level}&s=Galile',
                copyright: 'Google Maps',
            }),
            id: 'googlemaps',
            thumbnailUrl: '/img/googlemaps.png',
            title: 'Google Maps',
        }),
        new Basemap({
            baseLayers: new WebTileLayer({
                urlTemplate : 'https://mts1.google.com/vt/lyrs=m@221097413,traffic&hl=x-local&src=app&x={col}&y={row}&z={level}&s=Galile',
                copyright: 'Google Maps: Tráfico',
            }),
            id: 'googletra',
            thumbnailUrl: '/img/googleroad.png',
            title: 'Google Tráfico',
        }),
    ];

    localSource = new LocalBasemapsSource({
        basemaps : mapas,
    });

});
export default class BasemapCollection {
    public static getbasemapslocalSource = function() {
        return localSource;

    };
}
